// extracted by mini-css-extract-plugin
module.exports = {"closingYear":"configuration_closingYear__2FjoZ","closingYearSelector":"configuration_closingYearSelector__3Xd2J","closingYearButton":"configuration_closingYearButton__2t_OL"};